module.exports = __webpack_public_path__ + "static/media/watch1_before.38995c76.jpg";